import { render, staticRenderFns } from "./PlacementNetPrice.vue?vue&type=template&id=7d045630&"
import script from "./PlacementNetPrice.vue?vue&type=script&lang=js&"
export * from "./PlacementNetPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports